import {API} from "@/utils/api";
import axios from 'axios';

export const namespaced = true;

export const state = () => ({
    status: '',
    token: localStorage.getItem('token') || '',
    verified: localStorage.getItem('verified') || '',
    user: {}
});

export const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    userData: state => state.user,
    verified: state => state.verified,
}

export const mutations = {
    auth_request(state) {
        state.status = 'loading'
    },
    auth_success(state, token, user) {
        state.status = 'success'
        state.token = token
        state.user = user
    },
    user_data(state, user) {
        state.user = user
        state.verified = user['email_verified_at'] ? 'yes' : 'no'
    },
    auth_error(state) {
        state.status = 'error'
    },
    logout(state) {
        state.status = ''
        state.token = ''
        state.verified = ''
    }
};

export const actions = {
    login({commit}, loginData) {
        return new Promise((resolve, reject) => {
            commit('auth_request');
            API.post('login', loginData).then((resp) => {

                const token = resp.data.jwt
                const user = resp.data.user;

                localStorage.setItem('token', token);
                localStorage.setItem('verified', user['email_verified_at'] ? 'yes' : 'no');

                API.defaults.headers.common['Authorization'] = token

                commit('auth_success', token, user)
                commit('user_data', user);

                resolve(resp)

            }).catch((error) => {
                commit('auth_error')
                localStorage.removeItem('token');
                reject(error)
            })
        })
    },
    register({commit}, registerData) {
        return new Promise((resolve, reject) => {
            commit('auth_request')
            API.post('register', registerData).then((resp) => {
                const token = resp.data.jwt
                const user = resp.data.user
                localStorage.setItem('token', token);
                localStorage.setItem('verified', user['email_verified_at'] ? 'yes' : 'no');
                API.defaults.headers.common['Authorization'] = token
                commit('auth_success', token, user)
                commit('user_data', user)
                resolve(resp)
            }).catch(err => {
                commit('auth_error', err)
                reject(err)
            })
        })
    },
    logout({commit}) {
        return new Promise((resolve, reject) => {
            commit('logout')
            localStorage.removeItem('token')
            localStorage.removeItem('verified')
            delete axios.defaults.headers.common['Authorization']
            resolve()
        })
    },
    setUser({commit}, userData) {

        return new Promise((resolve, reject) => {
            commit('user_data', userData);
            localStorage.setItem('verified', userData['email_verified_at'] ? 'yes' : 'no');
            resolve()
        })
    }
};

